import React, { useEffect } from 'react';
import { Box, Paper, Typography, Button, useTheme } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useNavigate } from 'react-router-dom';
import { useChat } from '../../context/chatContext'; // Import the context

const Success: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { fetchInitialData } = useChat(); // Get the refetch function

  useEffect(() => {
    // When the component mounts, refetch the user's settings and usage
    // to get the new tier information reflected in the UI immediately.
    fetchInitialData();
  }, [fetchInitialData]);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
      }}
    >
      <Paper
        elevation={10}
        sx={{
          padding: theme.spacing(6),
          borderRadius: '16px',
          textAlign: 'center',
          maxWidth: '450px',
          mx: 2,
          border: `1px solid ${theme.palette.success.main}`,
          backgroundColor: theme.palette.background.paper,
          animation: 'fadeIn 0.5s ease-in-out',
          '@keyframes fadeIn': {
            '0%': { opacity: 0, transform: 'scale(0.95)' },
            '100%': { opacity: 1, transform: 'scale(1)' },
          },
        }}
      >
        <CheckCircleOutlineIcon sx={{ fontSize: 70, color: theme.palette.success.main, mb: 2 }} />
        <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', mb: 2 }}>
          Payment Successful!
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          Thank you for your purchase. Your account has been upgraded, and all new features are now available.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={() => navigate('/')}
          sx={{
            borderRadius: '20px',
            px: 4,
            textTransform: 'none',
            fontWeight: 'bold',
          }}
        >
          Return to Enantio
        </Button>
      </Paper>
    </Box>
  );
};

export default Success;